import lodashDebounce from 'lodash/debounce';

export const debounce = <T extends unknown[]>(callback: (...args: T) => void, delay: number) =>
    lodashDebounce(callback, delay);
